import * as Color from "color"
import PptxGenJS, {
	Slide,
	ChartPieDataset,
	ChartOptions
} from "pptxgenjs"
import * as React from "react"
import * as ReactDOM from "react-dom"
import { IntlProvider } from "react-intl"
import InvestmentTable from "./investment-table"
import { ReportConfiguration } from "../../../configuration"
import {
	getChartColors,
	getChartFirstOfTwoOptions,
	getChartSecondOfTwoOptions
} from "../../pptx-configuration/charts"
import { MasterSlide } from "../../pptx-configuration/master-slides"
import {
	getPlaceholderChartBodyOptions,
	Placeholder
} from "../../pptx-configuration/placeholders"
import { getHtmlToPowerPointBaseOptions } from "../../pptx-configuration/slides"
import { DocumentSection } from "../../types"
import { formatTitle } from "../../utils"
import * as InvestmentDomain from "../../../../../domain/sfp/investment-domain"
import { LocalAuthority } from "../../../../../model"
import { ColorsHelper } from "../../../../../util/colors"
import * as Model from "../../../../../model"

export function checkInvestmentSection(
	configuration: ReportConfiguration
): boolean {
	return configuration.observation.investmentSection.tables
	|| configuration.observation.investmentSection.globalCharts
}

export function createInvestmentSection(
	pptx: PptxGenJS,
	configuration: ReportConfiguration,
	numbering: number[],
	localAUthority: LocalAuthority,
	years: number[],
	ppi: Model.Ppi,
	loans: any
): DocumentSection {
	const title = formatTitle("Investissement", numbering)
	const slides: Slide[] = []
	const investmentData = InvestmentDomain.createInvestmentData(
		localAUthority.observations,
		localAUthority.accounts,
		years,
		ppi,
		loans
	)
	const firstYear = years[0]
	const referenceYear = configuration.generalities.referenceYear
	const referenceYearIndex = years.findIndex(y => y === referenceYear)
	const lastYear = years[years.length - 1]
	const placeholderBodyOptions = getPlaceholderChartBodyOptions()

	if (configuration.observation.investmentSection.tables) {
		const tempDiv = document.createElement("div")
		document.head.appendChild(tempDiv)

		const tableId = "management-report-retrospective-investment-data"
		const table = <IntlProvider locale={navigator.language} defaultLocale="fr">
			<InvestmentTable
			currency={configuration.currency}
			id={tableId}
			investmentData={investmentData}
			locale={configuration.locale}
			roundness={configuration.generalities.roundness}
			enableHideZeroLines={configuration.generalities.enableHideZeroLines}
			tableConfiguration={configuration.table}
			years={years} />
		</IntlProvider>

		ReactDOM.render(table, tempDiv, () => {
			const options = getHtmlToPowerPointBaseOptions(title)
			pptx.addSlidesForTable(tableId, options)
			document.head.removeChild(tempDiv)
		})
	}

	if (configuration.observation.investmentSection.globalCharts) {
		const firstChartData: [ChartPieDataset] = [{
			labels: [], name: `Année ${referenceYear}`, values: [] }]
		const secondChartData: [ChartPieDataset] = [{
			labels: [], name: `Années ${firstYear} à ${lastYear}`, values: [] }]

		investmentData.forEach((row, rowIndex) => {
			if (InvestmentDomain.DATA_INVESTMENTS_ROW_INDEX === rowIndex) return

			firstChartData[0].labels.push(row.label)
			firstChartData[0].values.push(row.values[referenceYearIndex])

			secondChartData[0].labels.push(row.label)
			secondChartData[0].values.push(row.total)
		})

		const slide = pptx.addNewSlide(MasterSlide.Chart)

		slide.addText(title, { placeholder: Placeholder.Title })

		const baseColor = new Color(configuration.table.header.backgroundColor)
		const chartColors = getChartColors();

		const firstChartOptions: ChartOptions = {
			...getChartFirstOfTwoOptions(placeholderBodyOptions),
			title: firstChartData[0].name,
			chartColors
		}

		slide.addChart(pptx.charts.PIE, firstChartData, firstChartOptions)

		const secondChartOptions: ChartOptions = {
			...getChartSecondOfTwoOptions(placeholderBodyOptions),
			title: secondChartData[0].name,
			chartColors
		}

		slide.addChart(pptx.charts.PIE, secondChartData, secondChartOptions)

		slides.push(slide)
	}

	return { slides, title }
}



// WEBPACK FOOTER //
// ./src/component/management-report/generator/observation-generator/investment-generator/index.tsx